// extracted by mini-css-extract-plugin
module.exports = {"previewCell":"previewCell__wsQlF","documentPreview":"documentPreview__9rxI9"};